import type { IconSvgObject } from './types';

const SpoonIcon: IconSvgObject = [
  ["path", { d: "M21.105 2.89501C19.3895 1.17949 15.6577 2.1299 13.7277 4.05985C12.7084 5.07911 12.4603 6.75894 12.4307 7.9827C12.4075 8.93854 12.0953 9.89427 11.4105 10.5615L2.50346 19.2396C1.84652 19.8568 1.8303 20.895 2.46765 21.5324C3.105 22.1697 4.14323 22.1535 4.76036 21.4965L13.4385 12.5895C14.1057 11.9047 15.0615 11.5925 16.0173 11.5693C17.2411 11.5397 18.9209 11.2916 19.9402 10.2723C21.8701 8.34234 22.8205 4.61053 21.105 2.89501Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default SpoonIcon;
